import styled from '@emotion/styled';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { SocialAccountType, CampaignSocialMediaType } from '../../../../../__generated__/globalTypes';
import { formatIntNumber, formatPercent } from '../../../../../libs/format';
import { switchImageActive } from '../../../../../libs/SocialMedia';
import { YoutubeEngagementInfoProps } from '../types';

const YoutubeEngagementInfo = (props: YoutubeEngagementInfoProps) => {
  const { t } = useTranslation();
  const { postUrl, analysis } = props;

  return (
    <MainContainer>
      <Title>
        {t('General.Engagement')}
        <Anchor href={postUrl as string} target="_blank" rel="noreferrer">
          {`View on ${CampaignSocialMediaType.YOUTUBE}`}
        </Anchor>
      </Title>
      <EngagementContainer>
        <Engagement>
          <Icon src={switchImageActive(SocialAccountType.YOUTUBE, true)} alt="" />
          <CountWrapper>
            <Wrapper>
              <Value>{formatIntNumber(analysis.views || null)}</Value>
              <Unit>{t('General.Views')}</Unit>
            </Wrapper>
            <Wrapper>
              <Value>{formatIntNumber(analysis.likes || null)}</Value>
              <Unit>{t('General.Likes')}</Unit>
            </Wrapper>
            <Wrapper>
              <Value>{formatIntNumber(analysis.dislike || null)}</Value>
              <Unit>{t('Dislikes')}</Unit>
            </Wrapper>
            <Wrapper>
              <Value>{formatIntNumber(analysis.comments || null)}</Value>
              <Unit>{t('General.Comments')}</Unit>
            </Wrapper>
            <Wrapper>
              <Value>{formatPercent(analysis.positiveRate, true, 2)}</Value>
              <Unit>{t('General.positive rate')}</Unit>
            </Wrapper>

            <Wrapper>
              <Value>{formatPercent(analysis.negativeRate, true, 2)}</Value>
              <Unit>{t('General.negative rate')}</Unit>
            </Wrapper>
            <Wrapper>
              <Value>{formatIntNumber(analysis.shares || null)}</Value>
              <Unit>{t('General.Shares')}</Unit>
            </Wrapper>
            <Wrapper>
              <Value>{formatIntNumber(analysis.impressions || null)}</Value>
              <Unit>{t('General.Imps')}</Unit>
            </Wrapper>
            <Wrapper>
              <Value>{formatIntNumber(analysis.revenu || null)}</Value>
              <Unit>{t('General.Revenue')}</Unit>
            </Wrapper>
          </CountWrapper>
        </Engagement>
      </EngagementContainer>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  margin-bottom: 16px;
`;

const EngagementContainer = styled.div`
  padding-bottom: 16px;
`;

const Engagement = styled.div`
  display: flex;
  align-items: flex-start;

  div:not(:last-of-type) {
    border-right: 1px solid #dee5ec;
  }
`;

const Icon = styled.img`
  width: 22px;
  margin-right: 12px;
`;

const Wrapper = styled.div`
  padding: 0 8px;
  margin-bottom: 16px;
`;

const Value = styled.h6`
  font-weight: 600;
  font-size: 13px;
  color: #27313b;
`;

const Unit = styled.p`
  margin-top: 1px;
  color: #6e7c89;
  font-size: 10px;
  white-space: nowrap;
`;

const CountWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Anchor = styled.a`
  margin-left: 17px;
  color: #179cd7;
  font-size: 12px;
  font-weight: normal;

  &:hover {
    text-decoration: underline;
  }
`;
const Title = styled.h6`
  display: flex;
  margin-bottom: 8px;
  color: #27313b;
  font-size: 12px;
  font-weight: 600;
`;

export default YoutubeEngagementInfo;
